import React, { useMemo, useState } from 'react'
import { BsSearch } from 'react-icons/bs'
import ModuleAcordeon from '../ModuleAcordeon'
import { Container, Search } from './styles'
import { Course as ICourse } from '../../../../types/course'
import { useGetProgressInfo } from 'pages/Course/hooks/use-get-progress-info'

interface CourseModulesProps {
  children: any[]
  courseId: string
  orderId: string
  course?: ICourse
}

const CourseModules: React.FC<CourseModulesProps> = ({ children, courseId, orderId, course }) => {
  const [search, setSearch] = useState<string>('')

  const swrProgressInfo = useGetProgressInfo(
    courseId,
    children.map((item) => item.ref)
  )

  const loading = swrProgressInfo.isLoading
  const modules = swrProgressInfo.isLoading
    ? children
    : children.map((item) => {
        const moduleProgress = swrProgressInfo.data.modulesProgress.find(
          (itemList) => String(item.ref) === String(itemList.moduleRef)
        )

        item.progressInfo = moduleProgress
        item.videoTime = moduleProgress?.videoTime || 0
        item.readingTime = moduleProgress?.readingTime || 0

        item.notification = moduleProgress?.notification || {}

        return item
      })

  const filteredModules = useMemo(() => {
    if (search === '') {
      return modules
    }

    return modules.filter(
      (item) =>
        (item.name.toLowerCase().includes(search.toLowerCase()) ||
          'resume'.toLowerCase().includes(search.toLowerCase())) &&
        item
    )
  }, [modules, search])

  const handleChange = (e: any): any => setSearch(e.target.value)

  return (
    <Container>
      <h2>Módulos</h2>
      <Search>
        <BsSearch />
        <input placeholder="Buscar módulo" onChange={handleChange} />
      </Search>
      {filteredModules.map((module) => (
        <div key={module._id}>
          <ModuleAcordeon
            key={module._id}
            name={module?.subject}
            module={module}
            courseId={courseId}
            orderId={orderId}
            total={module.children.length}
            term={search}
            course={course}
            loading={loading}
            progress={module.progressInfo?.progress}
            buildingContent={module.buildingContent}
            loadingProgressInfo={swrProgressInfo.isLoading}
          />
        </div>
      ))}
    </Container>
  )
}

export default CourseModules
